/** 근거 창 치수. 창과, 창 자리를 남기고 스크롤하는 선택 훅이 같이 쓴다 */
export const EVIDENCE_HEIGHT_PX = 600;
/** 화면 가장자리·선택 셀과의 간격 */
export const EVIDENCE_GAP_PX = 16;
/** 셀 하단 아래에 화면 안으로 남겨야 하는 높이 — 간격 + 창 + 간격 */
export const EVIDENCE_RESERVE_BELOW_PX =
  EVIDENCE_GAP_PX + EVIDENCE_HEIGHT_PX + EVIDENCE_GAP_PX;
